/** Pure helpers for Content Project card footer actions (unit-testable). */

export function stopPropagationAndRun(
  event: { stopPropagation: () => void },
  action: () => void,
): void {
  event.stopPropagation()
  action()
}

export function isCardNavigationKey(key: string): boolean {
  return key === 'Enter' || key === ' '
}
